<template>
  <div>
    <navigationBar :fill="true" />
    <div class="width-1200">
      <breadcrumb />
    </div>
    <div class="width-1200">
      <div class="search-warrap">
        <div class="search-input-warrp">
          <Input
            class="height64 bg-color-242631"
            style="width: 500px"
            v-model.trim="name"
            clearable
            placeholder="请输入域名：如baidu.com"
          />
          <Select
            class="height64 bg-color-3a3c46"
            style="width: 450px"
            v-model="sufSelectList"
            filterable
            multiple
            placement="bottom"
          >
            <Option
              v-for="item in domainQueryData.domainSuffix"
              :value="item.domainSufName"
              :key="item.domainSufName"
              >{{ item.domainSufName }}</Option
            >
          </Select>
          <Button
            class="search-btn"
            type="info"
            icon="ios-search"
            @click="search"
            >查询</Button
          >
        </div>
        <div class="table-result">搜索结果</div>
        <template v-if="isShow">
          <div class="showSensitive">限制注册！</div>
        </template>
        <template v-else>
          <Table
            class="bg-color-242631"
            ref="selection"
            :loading="loading"
            :show-header="false"
            :columns="columns"
            :data="list"
            @on-row-click="tableSelect"
            @on-select="select"
            @on-select-cancel="selectCancel"
          >
            <template slot="registerStatus" slot-scope="{ row }">
              <span :style="{ color: row.status === 1 ? '#C4332E' : '' }">{{
                row.status | registerStatus
              }}</span>
            </template>
            <template slot="price" slot-scope="{ row }">
              <span style="color: #c4332e">{{ row.price || "" }}元/首年</span>
            </template>
            <template slot="action" slot-scope="{ row, index }">
              <div style="display: flex; justify-content: flex-end">
                <Button
                  class="bg-color-51525B"
                  v-if="row.status === 0"
                  @click.stop="singleAddCart(row, index)"
                  >加入购物车</Button
                >
              </div>
            </template>
          </Table>
          <div style="margin-top: 20px">
            <Button
              class="bg-color-fff"
              type="primary"
              ghost
              @click="allSelect"
              >{{ allCheck ? "取消全选" : "全选" }}</Button
            >
            <Button
              class="bg-color-C4332E"
              style="margin-left: 20px"
              type="primary"
              @click="batchBuy"
              :disabled="!_disabled"
              :loading="t_allDisabled"
              >批量加入购物车</Button
            >
          </div>
        </template>
      </div>
    </div>
    <footBar />
  </div>
</template>
<script>
import navigationBar from "components/navigationBar.vue";
import breadcrumb from "components/breadcrumb.vue";
import footBar from "components/footBar.vue";
import { searchDomain, addShopCart } from "api/domain.js";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "price",
  components: {
    navigationBar,
    breadcrumb,
    footBar,
  },
  filters: {
    registerStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未注册";
          break;
        case 1:
          title = "已注册";
          break;
        case 2:
          title = "查询失败";
          break;
      }
      return title;
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.length > 0) {
          this.allCheck = val.every((o) => o._checked);
        }
      },
    },
  },
  computed: {
    ...mapState(["token", "domainQueryData", "searchData"]),
    _disabled() {
      const checkedArr = this.list.filter((o) => o._checked);
      return checkedArr && checkedArr.length > 0;
    },
    domainSuffix() {
      return this.domainQueryData.domainSuffix.length > 0
        ? this.domainQueryData.domainSuffix
        : [];
    },
  },
  data() {
    return {
      name: "",
      columns: [
        {
          type: "selection",
          width: 60,
        },
        {
          key: "dn",
        },
        {
          slot: "registerStatus",
        },
        {
          slot: "price",
        },
        {
          slot: "action",
        },
      ],
      list: [],
      allCheck: false,
      sufList: [],
      loading: false,
      sufSelectList: [],
      count: 1,
      t_disabled: false,
      t_allDisabled: false,
      isShow: false,
      sensitiveWords: "", //敏感词
    };
  },
  async created() {
    this.name = this.$route.query.name;

    if (
      this.domainQueryData.domainSuffix.length === 0 ||
      this.domainQueryData.sensitiveWords.length === 0
    ) {
      this.ACT_DOMAIN_QUERY();
    }

    if (!this.isShow) {
      this.sufSelectList = [...this.searchData];
      this.search();
    }
  },
  beforeDestroy() {
    this.MTU_SEARCH_DATA([]);
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    ...mapMutations(["MTU_SEARCH_DATA"]),
    batchBuy() {
      this.goodsNames = [];
      // 判断登录
      if (!this.token) {
        this.$router.push({ name: "login" });
        return;
      }
      const allData = this.list.filter((o) => o._checked);
      if (allData.length === 0) {
        this.$Message.warning("请选择要购买的域名！");
        return false;
      }
      this.goodsNames = allData.map((o) => {
        return o.dn;
      });
      this.t_allDisabled = true;
      this.req_addShopCart(this.goodsNames);
    },
    // // 搜索
    async req_search(suf) {
      if (this.name !== this.$route.query.name) {
        this.$router.replace("/search?name=" + this.name);
      }
      const list = {
        list: [`${this.name}${suf}`],
        houzhui: suf,
      };
      this.loading = true;
      this.count += 1;
      const { code, data } = await searchDomain(list);
      if (this.count >= this.sufSelectList.length) {
        this.count = 1;
        this.list = [];
      }
      this.loading = false;
      if (code === 200) {
        if (data != null) {
          let filter = data.filter(item => {
            return item.status == 3
          })
          if (filter != null && filter.length > 0) {
            this.isShow = true
          }
        }
        const temp = data.map((o) => {
          return { ...o, _checked: false, _disabled: o.status === 1 };
        });
        this.list = [...this.list, ...temp];
      }
    },
    // 加入购物车
    async req_addShopCart() {
      try {
        const { code, data } = await addShopCart({
          domains: this.goodsNames,
          type: 0,
        });
        this.t_disabled && (this.t_disabled = false);
        this.t_allDisabled && (this.t_allDisabled = false);
        if (code === 200) {
          if (data.length === 0) {
            this.$Message.success("添加成功！");
            this.$router.push("/cart");
          } else {
            this.result = data;
          }
        }
      } catch (error) {
        this.t_disabled && (this.t_disabled = false);
        this.t_allDisabled && (this.t_allDisabled = false);
        console.log(error);
      }
    },
    // 搜索事件
    search() {
      this.name = this.name.replace(/\s*/g, "");
      if (!this.name) {
        this.$Message.warning("请输入要搜索的域名！");
        return false;
      }

      if (this.sufSelectList.length === 0) {
        this.$Message.warning("请选择要查询的后缀！");
        return false;
      }

      this.isShow = false;

      this.domainQueryData.sensitiveWords.map((item) => {
        if (this.name.toLowerCase().indexOf(item.toLowerCase()) !== -1) {
          this.isShow = true;
          return false;
        }
      });
      if (!this.isShow) {
        this.sufSelectList.forEach((o) => {
          this.req_search(o);
        });
      }
    },
    // 行选中
    tableSelect(row, index) {
      if (!row._disabled) {
        let temp = { ...this.list[index] };
        temp._checked = !temp._checked;
        this.$set(this.list, index, temp);
      }
    },
    // 全选
    allSelect() {
      const isAll = !this.allCheck;
      this.list.forEach((o, index) => {
        !o._disabled && (o._checked = isAll);
        this.$set(this.list, index, o);
      });
    },
    // 选中
    select() {
      let row = arguments[1];
      if (!row._disabled) {
        let index = this.list.findIndex((o) => o.dn === row.dn);
        row._checked = true;
        this.$set(this.list, index, row);
      }
    },
    // 取消选中
    selectCancel() {
      let row = arguments[1];
      let index = this.list.findIndex((o) => o.dn === row.dn);
      row._checked = false;
      this.$set(this.list, index, row);
    },
    //单个添加购物车
    async singleAddCart(item) {
      this.goodsNames = [];
      this.t_disabled = true;
      if (!this.token) {
        this.$router.push({ name: "login" });
        return;
      }
      this.goodsNames = [item.dn];
      this.req_addShopCart(this.goodsNames);
    },
  },
};
</script>
<style lang="less" scoped>
.search-warrap {
  margin-top: 50px;
  padding: 40px 30px;
  border-radius: 25px;
  background-color: #FFFFFF;
  border: 1px solid #E9E9E9;
  .search-input-warrp {
    .flex(space-between, center);
  }
}
.showSensitive {
  width: 100%;
  text-align: center;
  font-size: 20px;
  padding: 20px 0;
  color: rgb(196, 51, 46);
}
</style>
